import { Box, Container, List, Tab, Tabs, Typography } from "@mui/material";
import { connect } from "react-redux";
import { CanalDistribuicaoViewProps, mapDispatchToCanalDistribuicaoProps, mapStateToCanalDistribuicaoProps } from "../canalDist.controll";
import { a11yProps, TabPanel } from "../../../components/tab";
import { CanalDistList } from "./canalDist.funcList";
import { Funcionario } from "../../funcionario/funcionario.model";
import { CanalDistEstoque } from "./canalDist.estoque";
import { CanalDistFinanceiro } from "./canalDist.financeiro";
import { CanalDistMov } from "./canalDist.mov";
import { ToolbarList, ToolbarModal } from "../../../components/toolbar";
import { Add, Create, DeliveryDining, GroupOff } from "@mui/icons-material";
import { useEffect } from "react";
import Modal from "../../../components/modal";
import { CanalDistribuicaoCadastro } from "./canalDist.cad";
import { CanalDistribuicao, intialValueCanalDistribuicao } from "../canalDist.model";


interface CanalDistShellView extends CanalDistribuicaoViewProps {
    readViewOnShow: boolean
}

function CanalDistShell(props: CanalDistShellView) {
    const { canalDistribuicaoActions, canalDistribuicaoState, funcionarioState, funcionarioActions, } = props
    const { setTabValue, readView, setClearValue,setShowModalEditarCanalDist,set,abrirCanalDist } = canalDistribuicaoActions
    const { tabValue, row, rows,showModalEditarCanalDist } = canalDistribuicaoState
    console.log("props CanalDistShell",props);

    useEffect(() => {
        if (props.readViewOnShow) {
            readView({
                viewName: "func/canal_dist_all_open_by_id",
                resultViewFull: false,
                opt: {}
            })
            return () => {
                console.log("chamou resetCAnal")
                setClearValue()
            }
        }

    }, [])



    const handleChangeTab = (event: React.SyntheticEvent, value: any) => {
        setTabValue(value);
    }

    function Cadastro() {
        return CanalDistribuicaoCadastro({
            ...props,
            handleCloseView: ()=> setShowModalEditarCanalDist(false)
        }).renderModal({
            handleClose:()=> setShowModalEditarCanalDist(false),
            show: showModalEditarCanalDist,
            width:"sm",
            heigth: "auto",
        })
    }   
    
    const handleAbrirCanal = () => {
        abrirCanalDist(true)
    }

    return (
        <Box sx={{display: "flex", flex:1, flexDirection:"column", width: "100%"}}>
            <ToolbarList
                title="Canal de distribuição"
                buttonNovo={
                    { title: "Abrir canal de distribuição", show: true, onClick:handleAbrirCanal }
                }
                elevation={2}

            />
            <Cadastro />
            <Box sx={{ display: "flex", flex: 1, flexDirection: "row", width: "100%" }}>

                {rows.length > 0 ? (
                    <>
                        <Box sx={{ display: "flex", flex: 1 }}>
                            <CanalDistList
                                {...props}
                            />
                        </Box>
                        {row._id ? (
                            <Box sx={{ display: "flex", flex: 3, flexDirection: "column", pt: 1, width: "100%" }}>
                                <ToolbarList
                                    title={`Canal de Distribuição:  ${row.funcionario.nome}`}
                                    subtitle={row.situacao}
                                    elevation={0}
                                    buttonNovo={{
                                        show: false,
                                        onClick: () => { },
                                        title: ""
                                    }}
                                    buttonEnd={{
                                        Icon:()=><Create />,
                                        onClick:()=>setShowModalEditarCanalDist(true),
                                        title:"Alterar Canal de distribuição"
                                    }}

                                />

                                <Container>
                                    <Box sx={{ display: "flex", flex: 1, borderBottom: 1, borderColor: 'divider' }}>
                                        <Tabs value={tabValue} onChange={handleChangeTab} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
                                            <Tab label={<Typography variant="subtitle1">{"Estoque"}</Typography>} {...a11yProps(0)} />
                                            <Tab label={<Typography variant="subtitle1">{"Movimentações"}</Typography>} {...a11yProps(1)} />
                                            <Tab label={<Typography variant="subtitle1">{"Financeiro"}</Typography>} {...a11yProps(2)} />
                                        </Tabs>
                                    </Box>
                                    <TabPanel value={tabValue} index={0}  >
                                        <CanalDistEstoque  {...props} />
                                    </TabPanel>
                                    <TabPanel value={tabValue} index={1}   >
                                        <CanalDistMov {...props} />

                                    </TabPanel>
                                    <TabPanel value={tabValue} index={2}  >
                                        <CanalDistFinanceiro {...props} />
                                    </TabPanel>
                                </Container>


                            </Box>
                        ) : (
                            <Box sx={{ display: "flex", flex: 3, flexDirection: "column", justifyContent: "center", pt: 1, width: "100%" }}>
                                <DeliveryDining sx={{ alignSelf: 'center', fontSize: 60 }} />
                            </Box>
                        )}
                    </>

                ) : (
                    <Box sx={{ display: "flex", flex: 3, flexDirection: "column", justifyContent: "center", alignItems: "center", pt: 1, width: "100%" }}>
                        <Typography variant="h5">Não há Canais de Distribuição ativo</Typography>
                        <GroupOff sx={{ alignSelf: 'center', fontSize: 60 }} />
                    </Box>
                )}

            </Box>
        </Box>

    )
}

const CanalDistShellView = connect(mapStateToCanalDistribuicaoProps, mapDispatchToCanalDistribuicaoProps)(CanalDistShell);

export default CanalDistShellView

//Criar o componente modal de CanalDistShellModal

export function CanalDistShellModal(props: CanalDistribuicaoViewProps) {

    const { showCadModal } = props.canalDistribuicaoState

    const handleClose = () => {
        const { setClearValue, setShowCadModal } = props.canalDistribuicaoActions
        setShowCadModal(false);
        setClearValue();
    }

    return (
        <Modal
            component={<CanalDistShellView readViewOnShow={false} />}
            open={showCadModal}
            handleClose={handleClose}
            heigth="100%"
            width="lg"
            handleOnKeyDown={() => { }}
        />
    )
}